<template>
  <div>
    <div class="card-container uk-width-1-1 uk-grid" uk-grid>
      <div class="uk-width-1-5">
        <img :src="image" class="card-content-image"/>
      </div>
      <div class="uk-width-4-5">
        <div class="heading">
          <span >{{$t('declinedResourcesCard.heading')}}</span>
        </div>
        <div class="description">
          <span v-html="$t('declinedResourcesCard.description1')"></span>
        </div>
        <div class="description">
          <span v-html="$t('declinedResourcesCard.description2')"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconUtil from '../../../../utils/icon-util'
  import * as misc from '../../../../enums/misc'

  export default {
    name: 'declined-resource-card',
    created() {
      this.image = iconUtil.resolve(misc.DECLINED_RESOURCES_CARD)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../styles/breakpoints';
  @import '../../../../styles/colours';

  .card-container {
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 15px;
    margin-bottom: 10px;
    min-height: 194px;

    &:hover {
      background-color: #ffffff;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
      cursor: pointer;
    }
  }

  .heading {
    font-size: 18px;
    font-weight: bold;
    color: $content-text;
    padding-bottom: 17px;
  }

  .description {
    /deep/
    a {
      color: $content-link-blue;
      font-weight: bold;
    }
    padding-bottom: 5px;
    font-size: 16px;
    line-height: 1.44;
  }

  .uk-width-1-1 {
    padding: 0px;
  }

  .uk-width-1-5 {
    padding: 0 101px 0 0;
  }

  .uk-width-4-5 {
    padding: 40px 63px 0 101px;
  }

  .top-padding {
    padding-top: 10px;
  }

  .left-padding {
    padding-left: 10px;
  }

  .card-content-image {
    min-height: 120px;
    min-width: 131px;
    margin: 38px 0 36px 112px;
  }

  .uk-grid {
    margin-left: 0;
    padding-left: 0;
  }

  @media screen and (max-width: $breakpoint-large) {
    .card-content-image {
      margin: 38px 0 36px 70px;
    }
  }

  @media screen and (min-width: $breakpoint-xlarge) {
    .card-content {
      font-size: 14px;
    }
  }
</style>
